import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import styled, { css } from 'styled-components'
import { ifNotProp, palette } from 'styled-tools'
import { Flex } from '@rebass/grid'
import Text from '../../atoms/Text'

const StyledConatiner = styled(Flex)`
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  padding: 1rem;
  cursor: pointer;
  outline: none;
  border-width: 2px;
  transition: all 0.3s ease;
  border-style: ${(props) => {
    if (props.isDragAccept || props.isDragReject) {
      return 'solid'
    }
    return 'dashed'
  }};
  border-color: ${(props) => {
    if (props.isDragAccept) {
      return palette('secondary', 1)
    }
    if (props.isDragReject) {
      return palette('error', 0)
    }
    if (props.isFocused) {
      return palette('primary', 1)
    }
    return palette('primary', 0)
  }};
  background-color: ${(props) => {
    if (props.isDragAccept) {
      return palette('secondary', 0)
    }
    if (props.isDragReject) {
      return palette('error', 0)
    }
    if (props.isFocused) {
      return palette('primary', 5)
    }
    return palette('white', 0)
  }}33;

  :hover {
    ${ifNotProp(['isFocused', 'isDragAccept', 'isDragReject'], css`
      background-color: ${palette('primary', 5)}80;
    `)}
  }
`

const FileDropzone = ({ onAdd, accept, placeholder, children, ...props }) => {
  return (
    <Dropzone
      onDrop={onAdd}
      accept={accept}
      {...props}
    >
      {({ getRootProps, getInputProps, isFocused, isDragAccept, isDragReject }) => (
        <StyledConatiner {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
          <input {...getInputProps()} />
          {children || (
            <Text align="center">{placeholder}</Text>
          )}
        </StyledConatiner>
      )}
    </Dropzone>
  )
}

FileDropzone.propTypes = {
  onAdd: PropTypes.func,
  accept: PropTypes.object,
  placeholder: PropTypes.string,
  children: PropTypes.node,
}

FileDropzone.defaultProps = {
  onAdd: () => {},
  accept: { '*': [] },
  placeholder: 'Drag & drop some files here, or click to select files',
  children: null,
}

export default FileDropzone
